export default {
  vendorAccept: {
    method: 'get',
    url: '/vendor/accept',
    headers: {
      tokenInvite: ''
    }
  },
  'get-list': {
    method: 'post',
    url: '/vendor/list'
  },
  'vendor-add': {
    method: 'post',
    url: '/vendor'
  },
  'vendor-edit': {
    method: 'put',
    url: '/vendor/ID'
  },
  'vendor-delete': {
    method: 'delete',
    url: '/vendor'
  },
  find: {
    method: 'get',
    url: '/vendor/find?key=KEY'
  },
  checkInvitation: {
    method: 'get',
    url: '/vendor/check-invitation',
    headers: {
      tokenInvite: ''
    }
  }
}
